import ComponentManager from "../../componentFramework";
import EventListenerManager from "../EventListenerManager";

@ComponentManager.register()
export default class RadioSelectableOptions {
	public static componentStyleClass = "radioSelectableOptions";

	private static readonly selectedMarker		= "radioSelectableOptions__item--isSelected";
	private static readonly itemElementQuery	= ".radioSelectableOptions__item";

	private readonly eventListenerManager = new EventListenerManager();

	constructor(private readonly rootElement: Element) {}

	@ComponentManager.on("ready")
	protected ready() {
		this.rootElement.querySelectorAll(RadioSelectableOptions.itemElementQuery).forEach(element => {
			if (element.querySelector("input[type='radio']:checked") !== null) {
				this.updateSelectedElement(element);
			}

			const input = element.querySelector<HTMLInputElement>("input[type='radio']");
			if (input !== null) {
				this.eventListenerManager.manage(input).addEventListener("change", () => this.updateSelectedElement(element));
				this.eventListenerManager.manage(element).addEventListener("click", () => input.click());
			}
		});
	}

	private updateSelectedElement(selected: Element) {
		this.rootElement.querySelectorAll(RadioSelectableOptions.itemElementQuery)
			.forEach(element => element.classList.remove(RadioSelectableOptions.selectedMarker));
		selected.classList.add(RadioSelectableOptions.selectedMarker);
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		this.eventListenerManager.removeListeners();
	}
}
